/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { CustomFieldsFragmentDoc } from '../../custom-fields/CustomFieldsBox.generated.js';
export type CrmCompanyCustomFieldsBox_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any, dataType: Types.CustomFieldDataType, group: string }> };

export const CrmCompanyCustomFieldsBox_CrmCompanyFragmentDoc = gql`
    fragment CrmCompanyCustomFieldsBox_CrmCompany on CrmCompany {
  id
  ...CustomFields
}
    ${CustomFieldsFragmentDoc}`;